<div class="body" [ngClass]="getBodyClass()">
  <app-usernav-log *ngIf="!isRedirectAccess"></app-usernav-log>

  <div class="dashboard-wrapper" *ngIf="isHomePage">
    <app-dashboard></app-dashboard>
  </div>
  
  <router-outlet></router-outlet>
</div>



